import React, { useEffect, useState } from "react";
import DonutChart from "./Chart/DonutChart";
// import BoxPlotChart from "./Chart/BoxPlotChart";
import BarChart from "./Chart/BarChart";
import ColumnChart from "./Chart/ColumnChart";
import StackBarChart from "./Chart/StackBarChart";
import ProgressChart from "./Chart/ProgressChart";
import EDCRecentActivity from "./EDCRecentActivity";
import SimplePieChart from "./Chart/SimplePieChart";
import GroupedBarChart from "./Chart/GroupedBarChart";
import GroupedColumnChart from "./Chart/GroupedColumnChart";
import StackedColumnsChart from "./Chart/StackedColumnsChart";
import MultipleRadialbarsChart from "./Chart/MultipleRadialbarsChart";
import { FaUser } from "react-icons/fa";
import { useParams } from "react-router";
import { GrValidate } from "react-icons/gr";
import { BsBuildingsFill } from "react-icons/bs";
import { FaFileWaveform } from "react-icons/fa6";
import { Card, Col, Container, Form, Placeholder, Row } from "react-bootstrap";
import { studyEDCDashboardGraph } from "../../../APIServices/studyEDCDashboardGraph";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { BiBell, BiComment, BiCommentCheck, BiCommentDetail, BiCommentDots, BiCommentEdit, BiCommentX } from "react-icons/bi";

const ModeWiseStudyGraph = ({ StudyMode, standardGraphRefresh, selected }) => {
  const { studyId } = useParams();
  const [totalSite, setTotalSite] = useState("");
  const [totalSiteLoader, setTotalSiteLoader] = useState(false);
  const [totalSiteInOneMonth, setTotalSiteInOneMonth] = useState("");
  const [totalSubject, setTotalSubject] = useState("");
  const [totalSubjectLoader, setTotalSubjectLoader] = useState("");
  const [totalSubjectInOneMonth, setTotalSubjectInOneMonth] = useState("");

  const [totalNotification, setTotalNotification] = useState(0);
  const [totalNotificationLoader, setTotalNotificationLoader] = useState(false);
  const [totalQueryStats, setTotalQueryStats] = useState(0);
  const [totalQueryStatsLoader, setTotalQueryStatsLoader] = useState(false);
  const [totalSDVStats, setTotalSDVStats] = useState(0);
  const [totalSDVStatsLoader, setTotalSDVStatsLoader] = useState(false);
  const [dvFormData, setDVFormData] = useState("");
  const [standardGraph, setStandardGraph] = useState([]);
  const [dvStatsLoader, setDVStatsLoader] = useState(false);
  const roleType = JSON.parse(localStorage.getItem("role"));

  const getTotalSite = async () => {
    setTotalSiteLoader(true);
    let data = await studySiteManagementServices.getTotalSite(
      studyId,
      StudyMode
    );
    setTotalSite(data?.totalSite);
    setTotalSiteInOneMonth(data?.lastMonthAdd);
    setTotalSiteLoader(false);
  };

  const getTotalSubject = async () => {
    setTotalSubjectLoader(true);
    let data = await studySubjectManagementServices.getTotalSubject(
      studyId,
      StudyMode
    );
    setTotalSubject(data?.totalSubject);
    setTotalSubjectInOneMonth(data?.lastMonthAdd);
    setTotalSubjectLoader(false);
  };

  const getStudyFormNotificationDashboardStats = async () => {
    setTotalNotificationLoader(true);
    let data =
      await studySubjectManagementServices.getStudyFormNotificationDashboardStats(
        studyId,
        StudyMode
      );
    setTotalNotification(data);
    setTotalNotificationLoader(false);
  };

  const getStudyFormQueryDashboardStats = async () => {
    setTotalQueryStatsLoader(true);
    let data =
      await studySubjectManagementServices.getStudyFormQueryDashboardStats(
        studyId,
        StudyMode
      );
    setTotalQueryStats(data);
    setTotalQueryStatsLoader(false);
  };

  const getStudyFormSDVDashboardStats = async () => {
    setTotalSDVStatsLoader(true);
    let data =
      await studySubjectManagementServices.getStudyFormSDVDashboardStats(
        studyId,
        StudyMode
      );
    setTotalSDVStats(data);
    setTotalSDVStatsLoader(false);
  };

  const getStudyDashboardDynamicGraph = async () => {
    let data = await studyEDCDashboardGraph.getStudyDashboardDynamicGraph(
      studyId,
      StudyMode
    );
    setStandardGraph(data?.data || []);
  };

  const getStudyLevelFormForDashboardStats = async () => {
    setDVStatsLoader(true);
    let data = await studyEDCDashboardGraph.getStudyLevelFormForDashboardStats(
      studyId
    );
    setDVFormData(data?.data);
    setDVStatsLoader(false);
  };

  useEffect(() => {
    getTotalSite();
    getTotalSubject();
    getStudyFormNotificationDashboardStats();
    getStudyFormQueryDashboardStats();
    getStudyFormSDVDashboardStats();
  }, [studyId, StudyMode, selected]);
  
  useEffect(() => {
    getStudyLevelFormForDashboardStats();
    getStudyDashboardDynamicGraph();
  }, [standardGraphRefresh, studyId, StudyMode, selected]);

  return (
    <>
      <Container fluid>
        <Row className="g-2">
          {(StudyMode === "DBP Mode" || StudyMode === "Live Mode" || "QC Mode") && (
            <>
              {selected.includes("Sites") && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 6 : 3}
                  sm={12}
                >
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BsBuildingsFill className="bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>Sites</Card.Title>
                          <Card.Text className="m-0">
                            {totalSiteLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalSite || 0
                            )}
                          </Card.Text>
                          <Card.Text>
                            {totalSiteLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 10 }} />
                              </Placeholder>
                            ) : (
                              (totalSite > totalSiteInOneMonth
                                ? totalSiteInOneMonth
                                : totalSite) || 0
                            )}{" "}
                            new site was assigned in past 1 month.
                          </Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Subjects") && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 6 : 3}
                  sm={12}
                >
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaUser className="bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>Subjects</Card.Title>
                          <Card.Text className="m-0">
                            {totalSubjectLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalSubject || 0
                            )}
                          </Card.Text>
                          <Card.Text>
                            {totalSubjectLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 10 }} />
                              </Placeholder>
                            ) : (
                              totalSubjectInOneMonth || 0
                            )}{" "}
                            new subject was added in past 1 month.
                          </Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Open Notification") && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 6 : 3}
                  sm={12}
                >
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiBell className=" bg-white shadow-sm text-danger" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalNotificationLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalNotification?.totalOpenNotification || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">
                            Open Notification
                          </Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Close Notification") && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 6 : 3}
                  sm={12}
                >
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiBell className="  bg-white shadow-sm text-success" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalNotificationLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalNotification?.totalClosedNotification || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">
                            Close Notification
                          </Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Open Query") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiCommentDots className="  bg-white shadow-sm text-danger" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalQueryStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalQueryStats?.totalOpenQuery || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Open Query</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Open Query") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiCommentCheck className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalQueryStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalQueryStats?.totalClosedQuery || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Close Query</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Close Query") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiCommentDetail className="  bg-white shadow-sm text-info" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalQueryStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalQueryStats?.totalAnsweredQuery || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Answered Query</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Answered Query") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiCommentX className="  bg-white shadow-sm text-warning" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalQueryStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalQueryStats?.totalCancelQuery || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Cancelled Query</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Cancelled Query") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiComment className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalQueryStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalQueryStats?.totalAutoQuery || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Auto Query</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Auto Query") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <BiCommentEdit className="  bg-white shadow-sm text-info" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalQueryStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalQueryStats?.totalManualQuery || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Manual Query</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Completed SDV") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <GrValidate className="  bg-white shadow-sm text-success" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalSDVStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalSDVStats?.totalCompletedSDV || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Completed SDV</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Pending SDV") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <GrValidate className="  bg-white shadow-sm text-warning" />
                        </div>
                        <div>
                          <Card.Title>
                            {totalSDVStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              totalSDVStats?.totalPendingSDV || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Pending SDV</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </>
          )}
          {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
            <>
              {selected.includes("Total Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className=" bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.totalForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Total Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Reviewed Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm text-success" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.reviewedForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Reviewed Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </>
          )}
          {StudyMode === "DBP Mode" && (
            <>
              {selected.includes("Assigned Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.totalAssignedForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Assigned Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Pending Review Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm text-warning" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.pendingReviewForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Pending Review</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </>
          )}
          {StudyMode === "DV Mode" && (
            <>
              {selected.includes("Pending Review Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm text-warning" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.pendingReviewFormByDV || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Pending Review</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </>
          )}
          {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
            <>
              {selected.includes("Log Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.logForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Log Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Regular Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.regularForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Regular Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Repeat Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.repeatForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Repeat Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
              {selected.includes("Special Form") && (
                <Form.Group as={Col} md={3} sm={6}>
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          <FaFileWaveform className="  bg-white shadow-sm" />
                        </div>
                        <div>
                          <Card.Title>
                            {dvStatsLoader ? (
                              <Placeholder animation="glow">
                                <Placeholder xs={6} style={{ width: 55 }} />
                              </Placeholder>
                            ) : (
                              dvFormData?.specialForm || 0
                            )}
                          </Card.Title>
                          <Card.Text className="m-0">Special Form</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </>
          )}
          {standardGraph?.map((graph, index) => (
            <>
              {graph?.graphType === "radialBar" && (
                <Form.Group
                  key={index}
                  as={Col}
                  md={selected.includes("Recent activity") ? 6 : 3}
                >
                  <div className="doughtnutClass border bg-light">
                    <div className="radiobar__chart__graph">
                      <h2 className="fontSize12" style={{ fontWeight: 500 }}>
                        {graph?.graphName || "Multiple Radial Bar Chart"}
                      </h2>
                    </div>
                    <MultipleRadialbarsChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "groupedBar" && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 12 : 6}
                >
                  <div className="doughtnutClass border bg-light">
                    <GroupedBarChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "donutGraph" && (
                <Form.Group
                  as={Col}
                  className="mb-3"
                  md={selected.includes("Recent activity") ? 6 : 3}
                >
                  <div className="doughtnutClass border bg-light">
                    <div className="radiobar__chart__graph pt-3">
                      <h2 className="fontSize12" style={{ fontWeight: 500 }}>
                        {graph?.graphName || "Donut Chart"}
                      </h2>
                    </div>
                    <DonutChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "paiGraph" && (
                <Form.Group
                  as={Col}
                  className="mb-3"
                  md={selected.includes("Recent activity") ? 6 : 3}
                >
                  <div className="doughtnutClass border bg-light">
                    <div className="radiobar__chart__graph pt-3">
                      <h2 className="fontSize12" style={{ fontWeight: 500 }}>
                        {graph?.graphName || "Pie Chart"}
                      </h2>
                    </div>
                    <SimplePieChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "progressBar" && (
                <Form.Group
                  as={Col}
                  className="mb-3"
                  md={selected.includes("Recent activity") ? 6 : 3}
                >
                  <div className="doughtnutClass border bg-light">
                    <div className="radiobar__chart__graph pt-3">
                      <h2 className="fontSize12" style={{ fontWeight: 500 }}>
                        {graph?.graphName || "Progress Chart"}
                      </h2>
                    </div>
                    <ProgressChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "stackBar" && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 12 : 6}
                >
                  <div className="doughtnutClass border bg-light">
                    <StackBarChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "groupColumn" && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 12 : 6}
                >
                  <div className="doughtnutClass border bg-light">
                    <GroupedColumnChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "stackColumn" && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 12 : 6}
                >
                  <div className="doughtnutClass border bg-light">
                    <StackedColumnsChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "bar" && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 12 : 6}
                >
                  <div className="doughtnutClass border bg-light">
                    <BarChart graph={graph} />
                  </div>
                </Form.Group>
              )}
              {graph?.graphType === "column" && (
                <Form.Group
                  as={Col}
                  md={selected.includes("Recent activity") ? 12 : 6}
                >
                  <div className="doughtnutClass border bg-light">
                    <ColumnChart graph={graph} />
                  </div>
                </Form.Group>
              )}
            </>
          ))}
          {/* <Form.Group as={Col} md={selected.includes("Recent activity") ? 12 : 6}>
            <div className="doughtnutClass border bg-light">
              <BoxPlotChart />
            </div>
          </Form.Group> */}
          {roleType === "ctms" && selected.includes("Recent activity") && (
            <Form.Group
              as={Col}
              md={selected.includes("Recent activity") ? 12 : 6}
            >
              <Card className="app-card border bg-light mb-3">
                <Card.Body>
                  <Card.Title>Recent activity</Card.Title>
                  <Card.Text className="m-0 mt-2">
                    <EDCRecentActivity StudyMode={StudyMode} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Form.Group>
            )}
          </Row>
      </Container>
    </>
  );
};

export default ModeWiseStudyGraph;
